import { OutboundResponseError } from "@/models/outboundresponserror";
import { IAsyncBatchResponse } from "@/models/batch";

export interface IOutboundResponse {
    isError?: boolean | null;
    message?: string | null;
    responseCode?: string | null;
    batchResult?: IAsyncBatchResponse | null;
    requestId?: string | null;
}

export class OutboundResponse {
    public isError!: boolean | null;
    public message!: string | null;
    public responseCode!: OutboundResponseError | null;
    public batchResult!: IAsyncBatchResponse | null;
    public requestId!: string | null;

    public constructor(other: IOutboundResponse) {
        if (!other) {
            throw new Error("Cannot construct outbound response from falsey IOutboundResponse.");
        }

        if (typeof other.isError === "boolean") {
            this.isError = other.isError;
        }
        else {
            this.isError = null;
        }

        this.requestId = other.requestId || null;
        
        this.responseCode = OutboundResponseError.convert(other.responseCode || null);

        this.message = other.message || null;
        this.batchResult = other.batchResult || null;
    }
}
